import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../shared/login.service';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent {
  email: string = '';
  password: string = '';
  errorLogin:boolean = false;
  loading: boolean = false;

  constructor(private router: Router, private loginService: LoginService) { }

  login() {
    this.loading = true;
    this.loginService.login({'email':this.email, 'password': this.password})
      .then(res =>{
        this.loading = false;
        let loggedUser = res;
        if(loggedUser.email){
          this.errorLogin = false;
          this.router.navigate([loggedUser.landPage]);
        }else{
          this.errorLogin = true;
        }
      }).catch(error =>{
        this.errorLogin = true;
        this.loading = false;
        console.error("invalid user");
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts